
export class MigrateMediaKit{
    fromMediaKitId: number;
    toMediaKitId: number;
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
}